const removeCartItemAction = index => ({
    type: 'remove_cart_item',
    payload: index
})

export default removeCartItemAction